class GrowthHeroText {
    static MAX_SPEED = 0.001; // Max rotation speed
    static ACCELERATION = 0.0001; // Acceleration on start rotation
    static DECELERATION = 0.00002; // Deceleration on stop rotation
    static DIRECTION = -1; // Rotation direction (-1 for CCW, 1 for CW)

    constructor(el) {
        this.el = el;
        this.illustrationEl = this.el.querySelector('.illustration-inner');
        this.angle = 0; // Starting angle
        this.speed = 0; // Starting speed
        this.isRotating = false; // Rotation state
        this.isAccelerating = false; // Acceleration state
        this.initialTransform = window.getComputedStyle(this.illustrationEl).transform; // Save initial transform

        this.init();
    }

    init() {
        const targetEl = this.el.querySelector('.holder');

        targetEl.addEventListener('mouseenter', () => this.startRotation());
        targetEl.addEventListener('mouseleave', () => this.stopRotation());
    }

    startRotation() {
        this.isRotating = true;

        if (!this.isAccelerating) {
            this.accelerate();
        }
    }

    accelerate() {
        this.isAccelerating = true;

        const accelerate = () => {
            if (this.speed <= 0) {
                this.speed = 0; // Ensure speed is not negative due to deceleration
            }

            if (!this.isRotating) {
                this.stopRotation();
                return;
            }

            if (this.speed >= GrowthHeroText.MAX_SPEED) {
                this.isAccelerating = false;
                this.rotate();
            } else {
                this.speed += GrowthHeroText.ACCELERATION;
                this.angle += this.speed * GrowthHeroText.DIRECTION;
                this.illustrationEl.style.transform = `${this.initialTransform} rotate(${this.angle}turn)`;
                requestAnimationFrame(accelerate);
            }
        };

        accelerate();
    }

    rotate() {
        if (!this.isRotating || this.speed < GrowthHeroText.ACCELERATION) {
            return;
        }

        this.angle += this.speed * GrowthHeroText.DIRECTION;
        this.illustrationEl.style.transform = `${this.initialTransform} rotate(${this.angle}turn)`;

        requestAnimationFrame(() => this.rotate());
    }

    stopRotation() {
        this.isRotating = false;
        this.isAccelerating = false;

        const decelerate = () => {
            if (this.speed <= 0) {
                this.speed = 0;
                return;
            }

            this.speed -= GrowthHeroText.DECELERATION;
            this.angle += this.speed * GrowthHeroText.DIRECTION;
            this.illustrationEl.style.transform = `${this.initialTransform} rotate(${this.angle}turn)`;

            if (this.isRotating) { // If the mouse comes back, start the rotation again
                this.startRotation();
                return;
            }

            requestAnimationFrame(decelerate);
        };

        decelerate();
    }
}

export default GrowthHeroText;
